<template>
    <div class="mls-provided-container" :class="theme">
        <div class="mls-provided" v-html="provided"></div>
    </div>
</template>

<script>
import { mapState } from '@/store/helpers';
import util from '@/common/util';
import { getProviderHtml } from '@/common/house';
import { phoneLoginFormat } from "@/common/format/phone-format.js";
export default {
    i18next: {
        ns: 'md-detail-info'
    },
    props: {
        theme: {
            type: String
        }
    },
    computed: {
        ...mapState({
            'info': store => store.listingDetail.info || {}
        }),
        provided() {
            //  format phone number
            const agentCellPhone = phoneLoginFormat(
                this.info.agentCellPhone
            );
            const agentOfficePhone = phoneLoginFormat(
                this.info.agentOfficePhone
            );
            let data = {
                provided: Object.keys(this.info)?.includes('isOfficeListed') ?
                    this.info.isOfficeListed ? getProviderHtml(this.info.mlsOrg?.template, {
                    ...this.info,
                    agentCellPhone,
                    agentOfficePhone
                }) : this.info.mlsOrg?.template : getProviderHtml(this.info.mlsOrg?.template, {
                    ...this.info,
                    agentCellPhone,
                    agentOfficePhone
                }),
            };
            if (!util.isSSRServer && window.globalHouseDataFormat) {
                window.globalHouseDataFormat(data, 'mls');
            }
            return data.provided;
        },
        
    }
};
</script>
<style lang="scss">
@import '../../theme/media.scss';
.mls-provided-container {
    .mls-provided {
        font-weight: normal;
        line-height: 1.5;
        margin-bottom: 15px;
    }
    &.standard .mls-provided {
        color: #595e6d;
        font-size: 14px;
        @include media-600 {
            font-size: 12px;
        }
    }
    &.broker .mls-provided {
        color: #505050;
        font-size: 14px;
        @include media-600 {
            margin-top: 10px;
            margin-bottom: 0;
            font-size: 12px;
        }
    }
    &.template4 .mls-provided {
        color: white;
        font-size: 14px;
        padding-right: 300px;
        @include media-600 {
            padding-right: 0;
        }
    }
    &.template1 .mls-provided {
        font-size: 14px;
        color: #202437;
        @include media-600 {
        }
    }
}
</style>
